<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import Vue from 'vue';
export default {
  name: 'App',
  data() {
    return {
      currentLang: this.getLangFromRoute(this.$route.path)
    };
  },
  watch: {
    '$route'(to) {
      this.currentLang = this.getLangFromRoute(to.path);
    }
  },
  methods: {
    getLangFromRoute(path) {
      if (path.indexOf('/en') !== -1) return 'en';
      if (path.indexOf('/fr') !== -1) return 'fr';
      if (path.indexOf('/de') !== -1) return 'de';
      if (path.indexOf('/es') !== -1) return 'es';
      if (path.indexOf('/pt') !== -1) return 'pt';
      if (path.indexOf('/ja') !== -1) return 'ja';
      if (path.indexOf('/ko') !== -1) return 'ko';
      if (path.indexOf('/ru') !== -1) return 'ru';
      if (path.indexOf('/tw') !== -1) return 'tw';
      if (path.indexOf('/th') !== -1) return 'th';
      return '';
    }
  },
  computed: {
    title() {
      switch (this.currentLang) {
        case 'en': return 'Pop Epoch - Rule Your Era, From Ice Age to Modern';
        case 'fr': return "Pop Epoch – Créez Votre Ère, de l'Âge glaciaire à l'Époque moderne";
        case 'de': return 'Pop Epoch – Erschaffe dein Zeitalter, von der Eiszeit bis zur Moderne';
        case 'es': return 'Pop Epoch – Crea tu historia, desde la Edad de Hielo hasta el mundo moderno';
        case 'pt': return 'Pop Epoch – Crie sua Era, da Era do Gelo à Modernidade';
        case 'ja': return '今すぐ事前登録！';
        case 'ko': return '지금 예약하기';
        case 'ru': return 'Зарегистрируйтесь заранее';
        case 'tw': return '立即預約';
        case 'th': return 'ลงทะเบียนล่วงหน้าเลย';
        default: return window.location.href || this.$route.path;
      }
    },
    keywords() {
      switch (this.currentLang) {
        case 'en': return 'bonk,tribe,civilization,prosperity,pop,epoch,ice,valorant,global,survival,building,puzzle,history';
        case 'fr': return "bonk,tribu,civilisation,prospérité,pop,epoch,glace,valorant,mondial,survie,construction,énigme,histoire";
        case 'de': return 'bonk,stamm,zivilisation,wohlstand,pop,epoch,eiszeit,valorant,global,überleben,bauen,puzzle,geschichte';
        case 'es': return 'choque, tribu, civilización, prosperidad, población, época, hielo, valorant, global, supervivencia, construcción, rompecabezas, historia';
        case 'pt': return 'bonk,tribo,civilização,prosperidade,pop,epoch,gelo,valorant,global,sobrevivência,construção,desafio,história';
        case 'ja': return 'インフルエンサーストーリー事前登録';
        case 'ko': return '<인플루언서 스토리: 빛나는 여정> 사전 예약';
        case 'ru': return 'Предварительная регистрация на «Influencer Story»';
        case 'tw': return '《網紅故事》預先註冊';
        case 'th': return 'Influencer Story ลงทะเบียนล่วงหน้า';
        default: return window.location.href || this.$route.path;
      }
    },
    description() {
      switch (this.currentLang) {
        case 'en': return 'Embark on an epic journey in Pop Epoch! Start from the Ice Age and lead your tribe to greatness. Innovate, build, and strategize to evolve your civilization. Meet legends like Archimedes and Joan of Arc, harness technology, and command armies to dominate through the ages. Your legacy starts here - join now and shape history!';
        case 'fr': return "Plongez dans une épopée grandiose avec Pop Epoch ! Commencez votre aventure à l'Âge glaciaire et guidez votre tribu vers la gloire. Innovez, construisez et affinez vos stratégies pour faire progresser votre civilisation. Rencontrez des légendes comme Archimède et Jeanne d'Arc, maîtrisez des technologies et commandez des armées pour dominer à travers les époques. Votre héritage commence ici. Rejoignez l'aventure et façonnez l'histoire !";
        case 'de': return "Begib dich auf eine epische Reise in Pop Epoch! Beginne in der Eiszeit und führe deinen Stamm zum Ruhm. Erfinde, baue und plane strategisch, um deine Zivilisation voranzubringen. Begegne Legenden wie Archimedes und Jeanne d’Arc, nutze Technologien und befehlige Armeen, um die Jahrhunderte zu dominieren. Dein Vermächtnis beginnt hier – tritt jetzt bei und gestalte die Geschichte!";
        case 'es': return '¡Emprende una travesía épica en Pop Epoch! Comienza en la remota Edad de Hielo y conduce a tu tribu hacia la grandeza. Innova, construye y despliega tu ingenio para impulsar el progreso de tu civilización. Encuentra a figuras legendarias como Arquímedes y Juana de Arco, domina nuevas tecnologías y lidera poderosos ejércitos para conquistar cada época. Tu legado empieza aquí: ¡únete ahora y dale forma a la historia!';
        case 'pt': return "Embarque em uma jornada épica no Pop Epoch! Comece na Era do Gelo e lidere sua tribo rumo à glória. Inove, construa e elabore estratégias para avançar sua civilização. Encontre lendas como Arquimedes e Joana d'Arc, domine tecnologias e comande exércitos para dominar territórios ao longo das eras. Seu legado começa aqui. Junte-se agora e faça história!";
        case 'ja': return '事前登録して報酬をゲットしよう！';
        case 'ko': return '지금 예약하고 상품 받기!';
        case 'ru': return 'Зарегистрируйтесь заранее, чтобы получить награды!';
        case 'tw': return '立即預約，領取獎勵！';
        case 'th': return 'ลงทะเบียนล่วงหน้าตอนนี้ เพื่อรับรางวัล!';
        default: return window.location.href || this.$route.path;
      }
    }
  },
  metaInfo () {
    return {
      title: this.title,
      meta: [
        { name: 'description', content: this.description },
        { name: 'keywords', content: this.keywords },
      ]
    };
  }
}

// 解决ios10及以上safari无法禁止缩放的问题
window.onload = function () {
  var lastTouchEnd = 0
  document.addEventListener('touchstart', function (event) {
    if (event.touches.length > 1) {
      event.preventDefault()
    }
  })
  document.addEventListener(
    'touchend',
    function (event) {
      var now = new Date().getTime()
      if (now - lastTouchEnd <= 300) {
        event.preventDefault()
      }
      lastTouchEnd = now
    },
    false
  )
  document.addEventListener('gesturestart', function (event) {
    event.preventDefault()
  })
  document.addEventListener('dblclick', function (event) {
    event.preventDefault()
  })
}
</script>
<style lang="stylus">
html{
  background: #000000;
}
#app {
  overflow-x: hidden;
  overflow-y: hidden !important;
}

</style>
